import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsNewBannerFrameworkActive = () => {
  return useIsFeatureActive('new_banner_framework').isActive;
};
